// src/contexts/AppProvider.js

import React from "react";
import { MediaProvider } from "./MediaContext";
import { CategoryProvider } from "./CategoryContext";
import { ClassProvider } from "./ClassContext";
// import { MapboxTokenProvider } from './MapboxTokenContext';
import { CombinationProvider } from "./CombinationContext";
import { TermineProvider } from "./TermineContext";
import { ModuleProvider } from "./ModuleContext";
import { KurseProvider } from "./KurseContext";
import { AusbildungProvider } from "./AusbildungContext";
import { PreisProvider } from "./PreisContext";
import { PriceCategoryProvider } from "./PriceCategoryContext";
import { LicenseProvider } from "./LicenseContext";
import { PlaceProvider } from "./PlaceContext";
import { AuthProvider } from "./AuthContext";
import { FahrzeugProvider } from "./FahrzeugContext";
import { AktionProvider } from "./AktionContext";
import { HomeSliderProvider } from "./HomeSliderContext";

const AppProvider = ({ children }) => {
  return (
    <AuthProvider>
      <MediaProvider>
        <HomeSliderProvider>

        <CategoryProvider>
          <LicenseProvider>
            <ClassProvider>
              <AusbildungProvider>
                {/* <MapboxTokenProvider> */}
                <CombinationProvider>
                  <PlaceProvider>
                    <TermineProvider>
                      <ModuleProvider>
                        <KurseProvider>
                          <PreisProvider>
                            <PriceCategoryProvider>
                              <FahrzeugProvider>
                                <AktionProvider>
                                  {children}
                                </AktionProvider>
                              </FahrzeugProvider>
                            </PriceCategoryProvider>
                          </PreisProvider>
                        </KurseProvider>
                      </ModuleProvider>
                    </TermineProvider>
                  </PlaceProvider>
                </CombinationProvider>
                {/* </MapboxTokenProvider> */}
              </AusbildungProvider>
            </ClassProvider>
          </LicenseProvider>
        </CategoryProvider>
        </HomeSliderProvider>

      </MediaProvider>
    </AuthProvider>
  );
};

export default AppProvider;
